import axios from "axios";
import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { z } from "zod";
import { baseUrl } from "../../../Environments/environment";
export default function ResetPassword() {
	const [formData, setFormData] = useState({
		password: "",
		confirmPassword: "",
	});
	const navigate = useNavigate();
	const location = useLocation();
	const token = new URLSearchParams(location.search).get("token");
	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const handleResetPassword = async (e) => {
		e.preventDefault();
		const { password, confirmPassword } = formData;

		const passwordZod = z
			.string()
			.min(8, "Password must be at least 8 characters long")
			.max(25, "Password must be at most 25 characters long")
			.refine((val) => /[A-Za-z]/.test(val), {
				message: "Password must contain at least one letter",
			})
			.refine((val) => /\d/.test(val), {
				message: "Password must contain at least one number",
			});
		const result = await passwordZod.safeParseAsync(password);
		if (!result.success) {
			toast.error(result.error.errors[0].message);
			return;
		}

		if (!password || !confirmPassword) {
			toast.error("Please fill in both password fields.");
			return;
		}

		if (password !== confirmPassword) {
			toast.error("Passwords do not match.");
			return;
		}

		try {
			const response = await axios.post(`${baseUrl}/auth/resetPassword`, {
				token,
				password,
				confirmPassword,
			});
			toast.success(
				"Reset password email sent successfully. Please check your inbox.",
			);
			navigate("/");
		} catch (error) {
			console.log(error);
			toast.error(
				error.response.data.message ||
					"An error occurred while resetting the password.",
			);
		}
	};
	return (
		<>
			<div className="px-6 py-8 sm:px-10">
				<h1 className="text-3xl font-bold tracking-tight text-gray-900">
					Reset Password
				</h1>
				<form
					onSubmit={handleResetPassword}
					method="POST"
					className="space-y-6 mt-6"
				>
					<div>
						<label
							htmlFor="password"
							className="block text-sm font-medium leading-6 text-gray-900 sr-only"
						>
							New Password
						</label>
						<div className="mt-2">
							<input
								id="password"
								name="password"
								type="password"
								required
								placeholder="Password"
								value={formData.password}
								onChange={(e) => handleChange(e)}
								className="block w-full pl-3 rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
							/>
						</div>
					</div>
					<div>
						<label
							htmlFor="confirmPassword"
							className="block text-sm font-medium leading-6 text-gray-900 sr-only"
						>
							Confirm Password
						</label>
						<div className="mt-2">
							<input
								id="confirmPassword"
								name="confirmPassword"
								type="password"
								placeholder="Confirm Password"
								required
								value={formData.confirmPassword}
								onChange={(e) => handleChange(e)}
								className="block pl-3 w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
							/>
						</div>
					</div>
					<div>
						<button
							type="submit"
							className="flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
						>
							Change Password
						</button>
					</div>
				</form>
			</div>
			<div className="border-t-2 border-gray-200 bg-gray-50 px-6 py-6 sm:px-10 w-full">
				<p className="text-xs leading-5 text-gray-500">
					Don't have an account?{" "}
					<Link className="underline text-indigo-700" to="/register">
						Sign up
					</Link>{" "}
				</p>
			</div>
		</>
	);
}
